import '../../../../node_modules/slick-carousel';

export class App {

  init() {

    this.accordionTrigger();
    this.megamenuCustom();


    this.sortUpdate();
    this.filterUpdate();

    this.accountOrderPage();

    this.basketSlideOut();
    this.cartBasket();
    this.productPageQuantity();

    this.forgotPassword();
    this.collectionToggleFilter();
    this.clearFilters();

    this.homeVideoLoad();

  }

  homeVideoLoad() {
    $(document).ready(function () {
      $('.video-homepage').addClass('show');
    });
  }

  collectionToggleFilter() {
    $('.filter-toggle-btn').on('click', function () {
      var currentFilter = $(this).data("toggle-id");

      $('#' + currentFilter).toggleClass("active");
      $(this).toggleClass("active");
    });
  }

  forgotPassword() {
    $('.recover-swap').on('click', function () {
      $('.reset-password-section').toggleClass("show");
      $('.account-section').toggleClass("show");
    });
  }


  productPageQuantity() {
    $('body').on('click', '.product-quantity-field .plus', function (e) {
      var selectedProduct = $(this).data("id");
      var maxQuantity = $('.product-current-stock').data('num');

      var val = parseInt($('.qty.qty-' + selectedProduct).val());


      if (!val) {
        val = 0;
      }
      val = val + 1;

      console.log(val);

      if (val <= maxQuantity) {
        $('.qty.qty-' + selectedProduct).val(parseInt(val));
      }
    });

    $('body').on('click', '.product-quantity-field .minus', function (e) {
      var selectedProduct = $(this).data("id");

      var val = parseInt($('.qty.qty-' + selectedProduct).val());
      if (!val) {
        val = 0;
      }
      if (val != 0) {
        val = val - 1;
        $('.qty.qty-' + selectedProduct).val(parseInt(val));
      }
    });
  }

  basketSlideOut() {
    $('body').on('change', '.cart-product  .qty', function (e) {
      var selectedProduct = $(this).data("id");
      var cartID = selectedProduct + 1;

      console.log(selectedProduct);

      var val = $(this).val();

      CartJS.updateItem(selectedProduct, val);
    });
    $('body').on('click', '.cart-product .plus', function (e) {
      var selectedProduct = $(this).data("id");

      console.log(selectedProduct);

      var val = parseInt($('.qty.qty-' + selectedProduct).val());
      if (!val) {
        val = 0;
      }
      val = val + 1;
      $('.qty.qty-' + selectedProduct).val(parseInt(val));

      CartJS.updateItem(selectedProduct, val);
    });

    $('body').on('click', '.cart-product .minus', function (e) {
      var selectedProduct = $(this).data("id");

      var val = parseInt($('.qty.qty-' + selectedProduct).val());
      if (!val) {
        val = 0;
      }
      if (val != 0) {
        val = val - 1;
        $('.qty.qty-' + selectedProduct).val(parseInt(val));
      }
      CartJS.updateItem(selectedProduct, val);
    });
  }

  cartBasket() {

    $('body').on('change', '.product-line .qty', function (e) {
      var selectedProduct = $(this).data("id");
      var cartID = selectedProduct + 1;

      console.log(selectedProduct);

      var val = $(this).val();

      CartJS.updateItem(selectedProduct, val);
    });

    $('body').on('click', '.product-line .plus', function (e) {
      var selectedProduct = $(this).data("id");
      var cartID = selectedProduct + 1;

      console.log(selectedProduct);

      var val = parseInt($('.qty.qty-' + selectedProduct).val());
      if (!val) {
        val = 0;
      }
      val = val + 1;
      $('.qty.qty-' + selectedProduct).val(parseInt(val));

      CartJS.updateItem(selectedProduct, val);
    });

    $('body').on('click', '.product-line .minus', function (e) {
      var selectedProduct = $(this).data("id");

      var val = parseInt($('.qty.qty-' + selectedProduct).val());
      if (!val) {
        val = 0;
      }
      if (val != 0) {
        val = val - 1;
        $('.qty.qty-' + selectedProduct).val(parseInt(val));
      }

      CartJS.updateItem(selectedProduct, val);
    });
  }

  accountOrderPage() {
    $('.order-tab').on('click', function () {
      $('.account-object').toggleClass("hide");
      $('.account-orders').toggleClass("show");
    });
  }

  clearFilters() {
    $('.clear-filters').on('click', function () {
      var cleanUrl = location.protocol + '//' + location.host; // build a clean url with no filters
      var currentPaths = window.location.pathname.split('/'); // split current url into its paths
      var lastPath = currentPaths[currentPaths.length - 1]; // get last item of array (current active filters)
      var secondLastPath = currentPaths[currentPaths.length - 2]; // get last item of array (current active filters)

      if (lastPath.includes("_c")) {
        window.location.href = cleanUrl + '/collections/' + secondLastPath; // clear but with the current location
      } else {
        window.location.href = cleanUrl + '/collections/' + lastPath; // clear but with the current location
      }
      // window.location.href = cleanUrl; // send user to new url

      // window.location.href = cleanUrl + '/collections/' + lastPath; // clear but with the current location
    });
  }

  filterUpdate() {

    // save and display current filters from parameters
    $(document).ready(function () {

      var currentPaths = window.location.pathname.split('/'); // split current url into its paths
      var lastPath = currentPaths[currentPaths.length - 1]; // get last path in url (the current filters)
      var currentFilters = lastPath.split('+'); // split the filters into individual items

      currentFilters.forEach(function (filter) { // for each filter in the array

        $('.form-checkbox-input.' + filter).prop('checked', true); // check its relative checkbox

        var itemLi = $('.form-checkbox-input.' + filter).parent(); // find checkbox of filter

        var itemUl = $(itemLi).parent(); // get parent of checkbox of filter

        var catList = $(itemUl).parent(); // get the list of filters

        if ($(itemUl).hasClass("moretext")) {
          $(itemUl).attr("style", "display: list-item;");
          catList = $(catList).parent();
        }

        $(catList).attr("style", "display: block;"); // open list of filters


      });
    });

    var currentPaths = window.location.pathname.split('/'); //split path items into array
    var lastPath = currentPaths[currentPaths.length - 1]; // get last item of array (current active filters)
    var currentFilters = lastPath.split('+'); // separate filters into array

    // add selected filters into array to add to url
    $('.filter-item').on('click', function () {

      $('.filter-container').addClass('disabled');

      var childCheckbox = $(this).find('.form-checkbox-input'); // find checkbox in selected item

      if ($(childCheckbox).is(':checked')) { // if the checkbox is checked

        $(childCheckbox).prop('checked', false); // uncheck it
        const index = currentFilters.indexOf($(childCheckbox).val()); // find value of unselected filter in filter array
        currentFilters.splice(index, 1); // remove said value from filter array

      } else {

        $(childCheckbox).prop('checked', true); // if checkbox isnt checked, check it
        currentFilters.push($(childCheckbox).val()); // add new filter to the filter array array

      }

      var collectionsLocation = currentPaths.shift(); // remove first item from current path
      var currentLocation = currentPaths.shift(); // store second item from current path ("collections")
      var currentCollection = currentPaths.shift(); // store third item from current path (the collection/category)
      var filtersString = currentFilters.join('+'); // convert array of filters to string and separate by +
      var cleanUrl = location.protocol + '//' + location.host; // build a clean url with no filters


      if (filtersString === "") {

        window.location.href = cleanUrl + '/' + currentLocation + '/' + currentCollection; // clear but with the current location

      } else {

        filtersString = filtersString.replace(currentCollection + '+', ''); // turn current filters into a string a separate with +
        var newUrl = cleanUrl + '/' + currentLocation + '/' + currentCollection + '/' + filtersString; // build new url and add new filter list on top
        window.location.href = newUrl; // send user to new url
      }


      // 
    });
  }


  sortUpdate() {

    $('.sortby-dropdown').on('click', function () {

      // manually gets key and value
      var newSort = $(this).attr("value");
      var sortType = $(this).attr("type");

      // Get the current URL
      var url = new URL(window.location.href);
      var pageUrl = location.protocol + '//' + location.host + location.pathname,
        urlPrefix = '';

      // Get the search parameters from the URL
      var params = new URLSearchParams(url.search);

      // check is parameters already exist
      if (params == '') {
        urlPrefix += sortType + '=' + newSort;
      } else {
        // Convert parameters to an object
        var paramsObj = {};
        params.forEach(function (value, key) {

          paramsObj[key] = value;

          if (key == 'sort_by') {
            urlPrefix += '&' + key + '=' + newSort;

          } else {
            urlPrefix += '&' + key + '=' + value;
          }
        });
      }


      var newUrl = pageUrl + '?' + urlPrefix;

      console.log(newUrl);

      // Convert parameters to an array
      // var paramsArray = Array.from(params);

      // Example usage
      // console.log(paramsObj); // Output the parameters as an object
      // console.log(paramsArray); // Output the parameters as an array

      window.location.href = newUrl;

      window.history.replaceState(null, 'Momentum Sort', newUrl);
      window.history.pushState(null, 'Momentum Sort', newUrl);
    });
  }

  megamenuCustom() {

    $("[data-menu='true']").click(function () {
      var isOpen = $(this).hasClass("open");
      var siblings = $(this).parent().siblings().find(".open");
      var openedMenu = siblings.data("menu-name");
      $(openedMenu).toggleClass("show");
      siblings.removeClass("open");
      $(this).toggleClass("open");
      var megamenu = $(this).data("menu-name");
      $(megamenu).toggleClass("show");
      if (!isOpen) {
        $("body").addClass("fixed-bg");
      } else {
        $("body").removeClass("fixed-bg");
      }
    });

  }

  accordionTrigger() {
    var accordionToggle = $('.accordion--trigger');

    $('body').on('click', '.accordion--trigger', function (event) {
      var currentObject = $(this), //Assigning current mouse over link

        currentObjectIndex = currentObject.data('index');
      var activeObject = $('.accordion--block__' + currentObjectIndex);
      var notActiveObjects = $('.accordion--block').not(activeObject);

      notActiveObjects.removeClass('active');
      if (activeObject.hasClass('active')) {

        activeObject.removeClass('active');
        currentObject.removeClass('active');
      } else {
        activeObject.addClass('active');
        currentObject.addClass('active');
        //$(this+' .icon').addClass('active');
      }

      $('.accordion--text').on('click', function (event) {
        event.stopPropagation();
      });

    });
  }

}
